import { db } from "../db";
import { ProjectConfig } from "../definitions";
import { recordSentry } from "utils/recordSentry";

export async function getAllProjectConfigs(): Promise<ProjectConfig[]> {
	try {
		const projectConfigs = await db.projectConfig.toArray();
		return projectConfigs;
	} catch (error) {
		recordSentry({ error, msg: "Error retrieving project configs:" });
	}
	return [];
}

export async function batchCreateProjectConfigs(projectConfigsToCreate: ProjectConfig[]): Promise<void> {
	try {
		await db.projectConfig.bulkPut(projectConfigsToCreate);
	} catch (error) {
		recordSentry({ error, msg: "Error creating project configs:" });
	}
}

export async function batchDeleteProjectConfigs(projectConfigsToDelete: string[]): Promise<void> {
	try {
		await db.projectConfig.bulkDelete(projectConfigsToDelete);
	} catch (error) {
		recordSentry({ error, msg: "Error deleting project configs:" });
	}
}
